import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import { BUSINESS } from '../config';

export default function Footer() {
  return (
    <footer className="bg-primary text-white" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Brand block — logo Météris officiel */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo-meteris.png"
                alt="Météris"
                className="h-12 w-12 rounded-full object-cover"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              PC neufs et reconditionnés sélectionnés et garantis par notre atelier.<br />
              Vente, conseil et retrait au cœur de Meaux.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading font-semibold text-lg uppercase tracking-wider mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-slate-400 hover:text-secondary transition-colors">Accueil</Link></li>
              <li><Link to="/catalogue" className="text-sm text-slate-400 hover:text-secondary transition-colors">Catalogue</Link></li>
              <li><Link to="/catalogue?condition=neuf" className="text-sm text-slate-400 hover:text-secondary transition-colors">PC neufs</Link></li>
              <li><Link to="/catalogue?condition=reconditionne" className="text-sm text-slate-400 hover:text-secondary transition-colors">PC reconditionnés</Link></li>
              <li><Link to="/compte" className="text-sm text-slate-400 hover:text-secondary transition-colors">Mon compte</Link></li>
              <li><Link to="/compte/favoris" className="text-sm text-slate-400 hover:text-secondary transition-colors">Favoris</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-secondary transition-colors">Contact</Link></li>
              <li><Link to="/cgv" className="text-sm text-slate-400 hover:text-secondary transition-colors">CGV</Link></li>
              <li><Link to="/mentions-legales" className="text-sm text-slate-400 hover:text-secondary transition-colors">Mentions légales</Link></li>
              <li><Link to="/confidentialite" className="text-sm text-slate-400 hover:text-secondary transition-colors">Confidentialité</Link></li>
            </ul>
          </div>

          {/* Boutique & contact — sans email */}
          <div>
            <h4 className="font-heading font-semibold text-lg uppercase tracking-wider mb-4">Boutique &amp; contact</h4>
            <ul className="space-y-4 text-slate-400">
              <li className="flex items-start gap-3">
                <Phone className="w-[18px] h-[18px] text-secondary mt-0.5 flex-shrink-0" />
                <a
                  href={`tel:${BUSINESS.telephoneRaw}`}
                  className="text-secondary font-bold hover:text-secondary/80 transition-colors"
                  data-testid="footer-phone"
                >
                  {BUSINESS.telephone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-[18px] h-[18px] text-secondary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white text-sm">{BUSINESS.adresse}</p>
                  <p className="text-xs text-slate-400">À côté du E-Leclerc</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-[18px] h-[18px] text-secondary mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white text-sm">Lun – Ven : 16h30 – 18h00</p>
                  <p className="text-xs text-slate-400">Retrait sans rendez-vous</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} — Tous droits réservés</p>
          <div className="flex gap-4">
            <Link to="/cgv" className="hover:text-slate-300 transition-colors">CGV</Link>
            <Link to="/mentions-legales" className="hover:text-slate-300 transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-slate-300 transition-colors">Confidentialité</Link>
            <Link to="/my" className="hover:text-slate-300 transition-colors">Administration</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
